import { ScanQrcodeCore } from './Core'
import { ScanQrcodeProps } from './interface'
import { ScanQrcodeStoreProvider } from './Store'

export const ScanQrcode = ({
  /* -------------------------------------------------------------------------- */
  /*                        ScanQrcodeStoreProvider Props                       */
  /* -------------------------------------------------------------------------- */
  autoLogin,
  onScan,
  onReload,
  /* -------------------------------------------------------------------------- */
  /*                            ScanQrcodeCore Props                            */
  /* -------------------------------------------------------------------------- */
  className,
  style,
  bordered,
  tip
}: ScanQrcodeProps) => {
  return (
    <ScanQrcodeStoreProvider
      autoLogin={autoLogin}
      onReload={onReload}
      onScan={onScan}
    >
      <ScanQrcodeCore
        bordered={bordered}
        className={className}
        style={style}
        tip={tip}
      />
    </ScanQrcodeStoreProvider>
  )
}
